import { createAction } from "@coverme/redux";
import Axios from "axios";

export const getPerson = (customerId, patientId) =>
    createAction("GET_PERSON", () => {
        return Axios.get(`/api/customer/${customerId}/person/external/${patientId}`).then(data => {
            return {
                        externalPersonId: patientId,
                        person: {
                            ...data.data,
                        },
                    };
        });
    });
